<template>
  <UikitDialog
    v-model="model"
    position="right"
    :full-height="laptopM || isDesktop"
    no-padding
    class="osk-points-transition-dialog"
  >
    <div class="osk-dialog-wrapper">
      <div class="osk-points-transition-dialog__title">
        {{ $t('product.ProductPointsDialog.title') }}
      </div>

      <div class="osk-points-transition-dialog__content">
        <div class="osk-points-transition-dialog__item">
          <div class="osk-points-transition-dialog__item-title">
            {{ $t('product.ProductPointsDialog.writtenOff') }}
          </div>

          <span>
            {{ minusPoints ? '–' : '' }}{{ $t('business.user.points', { count: minusPoints, text: numberFormat(minusPoints) }) }}
          </span>

          <span>
            {{ $t('business.onePointOneRuble') }}
          </span>
        </div>

        <div class="osk-points-transition-dialog__item">
          <div class="osk-points-transition-dialog__item-title">
            {{ $t('product.ProductPointsDialog.saveUp') }}
          </div>

          <span>
            +{{ $t('business.user.points', { count: plusPoints, text: numberFormat(plusPoints) }) }}
          </span>

          <span>
            {{ $t('business.onePointOneRuble') }}
          </span>
        </div>

        <div
          v-if="burningAmount"
          class="osk-points-transition-dialog__item osk-points-transition-dialog__item_full"
        >
          <div class="osk-points-transition-dialog__label">
            <UikitIcon
              name="Burn"
              size="s"
              class="osk-mr-xs"
              color="white"
            />

            {{ $t('business.user.points', { count: burningAmount, text: numberFormat(burningAmount) }) }}
          </div>

          {{ $t('product.ProductPointsDialog.burningPoints') }}
          <div
            class="osk-points-transition-dialog__link"
            @click="isDialog = true"
          >
            {{ $t('common.moreDetails') }}
          </div>
        </div>
      </div>

      <UikitButton
        full-width
        class="osk-mt-mlg"
        :size="isDesktop ? 'm' : 'l'"
        @click="closeDialog"
      >
        {{ $t('product.ProductPointsDialog.button') }}
      </UikitButton>
    </div>

    <template #dialogs>
      <BusinessPointsQrDialog v-model="isDialog" />
    </template>
  </UikitDialog>
</template>

<script setup lang="ts">
import { BonusesInfoDTO } from '~/restAPI/data-contracts';

const model = defineModel<boolean>({ required: true });

const props = defineProps<{
  bonusesInfo?: BonusesInfoDTO,
  burningAmount?: number,
}>();

const isDialog = ref(false);

const { laptopM, isDesktop } = useUiBreakpoints();
const { numberFormat } = useNumberFormatter();

const plusPoints = computed(() => props.bonusesInfo?.transferBonusesAmount?.total);
const minusPoints = computed(() => props.bonusesInfo?.withdrawBonusesAmount?.total);

function closeDialog() {
  model.value = false;
}
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-points-transition-dialog {
  z-index: 1010 !important;

  .osk-dialog-wrapper {
    justify-content: center;

    @media screen and (max-height: 375px) {
      justify-content: flex-start;
      padding-top: 64px;
    }

    @include media-query(lg-and-up) {
      @media screen and (max-height: 540px) {
        justify-content: flex-start;
        padding-top: 94px;
        padding-bottom: 54px;
      }
    }
  }

  .osk-dialog__close {
    @media screen and (max-width: 767px) {
      top: 12px;
      right: 12px;
    }
  }

  &__title {
    @include font-style(var(--font-size-heading), var(--line-height-heading), var(--font-weight-bold));
    padding: 10px 0;
    margin-top: 27px;
    margin-bottom: 22px;
  }

  &__content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: var(--indent-compact);
  }

  &__item {
    background: var(--grey-4);
    padding: var(--indent-mmedium) var(--indent-medium);
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &_full {
      grid-column: span 2;
    }
  }

  &__item-title {
    font-weight: var(--font-weight-bold);
    padding-right: 48px;
    margin-bottom: var(--indent-compact);
  }

  &__label {
    @include font-style(14px, normal, --font-weight-medium);
    background: linear-gradient(262.42deg, #3A3A3A 0%, #707070 93.72%);
    color: #fff;
    border-radius: 100px;
    padding: 2px 6px;
    margin-bottom: var(--indent-small);
    display: flex;
    width: auto;
    align-items: center;
    height: 25px;
  }

  &__link {
    display: inline-block;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
